module.exports = __webpack_public_path__ + "static/media/mobileban3.fc5e386d.jpg";